<template>
  <ul v-if="groupedList.length" :class="{ 'flex flex-col gap-y-10 md:gap-y-16': groupedList.length > 1 }">
    <template v-if="!(groupedList.length === 1 && !groupedList[0]?.title)">
      <li v-for="(group, index) in groupedList" :key="index">
        <AtomHeadingContentItem v-if="group.title" :title="group.title" />
        <ul>
          <li v-for="(item, item_index) in group.items" :key="item_index">
            <MoleculeFoldoutItem
              class="border-t md:border-t-2 border-solid border-app-primary-grey--black-squeeze"
              :class="{ 'border-b md:border-b-2': item_index + 1 === items.length }"
              :when="item.date ? new Date(item.date) : undefined"
              :label="item.label"
              :color-theme="colorTheme"
              :description="item.description"
              :anchor="item.anchorId ? item.anchorId : undefined"
            />
          </li>
        </ul>
      </li>
    </template>
    <template v-else>
      <li v-for="(item, index) in groupedList[0]?.items" :key="index">
        <MoleculeFoldoutItem
          class="border-t md:border-t-2 border-solid border-app-primary-grey--black-squeeze"
          :class="{ 'border-b md:border-b-2': index + 1 === items.length }"
          :when="item.date ? new Date(item.date) : undefined"
          :label="item.label"
          :color-theme="colorTheme"
          :description="item.description"
          :anchor="item.anchorId ? item.anchorId : undefined"
        />
      </li>
    </template>
  </ul>
</template>

<script setup lang="ts">
const props = defineProps({
  items: { type: Array as PropType<any[]>, required: true },
  colorTheme: { type: String, required: false, default: undefined },
})

/** A foldout group: an optional title plus the items that fall under it. */
type FoldoutGroup = { title: string | null; items: CmsData[] }

const groupedList = computed(() => {
  const newGroupedList: FoldoutGroup[] = []
  let pointer = -1
  props.items.forEach((item: CmsData) => {
    if (item.foldoutTitle || newGroupedList.length === 0) {
      pointer++
      newGroupedList[pointer] = {
        title: item.foldoutTitle ? item.foldoutTitle : null,
        items: [],
      }
    }
    newGroupedList[pointer]?.items.push(item)
  })
  return newGroupedList
})
</script>
